import { t } from "i18next"
import React from "react"

interface NegativePointsProps {
  x?: number
  y?: number
  width?: number
  height?: number
}

const NegativePoints = ({ x = 480, y = 480, width = 480, height = 470 }: NegativePointsProps): React.JSX.Element => {
  return (
    <g>
      <rect
        id="negative-points"
        className="droppable-target"
        x={x}
        y={y}
        width={width}
        height={height}
        fill="white"
        stroke="silver"
        strokeWidth="1"
        rx="6"
        ry="6"
      ></rect>
      <text fill="black" x={x + 15} y={y + 30} style={{ fontSize: 16 }}>
        {t("board.title.negative-points")}
      </text>
      <line x1={x} x2={x + width} y1={y + 60} y2={y + 60} stroke="#E5E5E5" strokeWidth="1"></line>
      <text fill="gray" x={x + 15} y={y + 45} textAnchor="start" dominantBaseline="middle" style={{ fontSize: 12 }}>
        {t("alert.onlyParticipants")}
      </text>
    </g>
  )
}

export default NegativePoints
